
  Vue.component('vue-notifier', {
    props: {
      duration: { type: Number, default: 10000 }
    },
    data() {
      return {
        type: 'light',
        visible: false,
        message: 'MESSAGGIO DI PROVA',
        autoClose: false,
        style: 'notice', // 'notice' | 'popup'
        actions: [],
        component: '',
        options: {},
        cssStyle: {},
        queue: []
      }
    },
    template: '#vue-notifier',
    computed: {},
    watch: {},
    methods: {
      setDefault() {
        this.type = 'light'
        this.visible = false
        this.message = 'MESSAGGIO DI PROVA'
        this.autoClose = false
        this.style = 'notice'
        this.actions = []
        this.component = ''
        this.options = {}
      },
      setNext() {
        if (!this.visible) {
          this.setDefault()
          if (this.queue.length > 0) {
            const param = this.queue.shift()
            this.style = param.style
            this.autoClose = param.autoClose !== false
            this.message = param.message
            this.type = param.type
            if (param.component) this.component = param.component
            if (param.options) this.options = param.options
            if (param.actions) this.actions = param.actions
            if (param.type) this.type = param.type
            if (param.cssStyle) this.cssStyle = param.cssStyle
            this.visible = true
            if (this.autoClose) {
              setTimeout(() => {
                this.visible = false
                this.setNext()
              }, this.duration)
            }
          }
        }
      },
      vnShow(param) {
        // this.setDefault()
        // this.style = 'notice'
        // this.autoClose = param.autoClose != false
        // this.message = param.message
        // this.type = param.type
        // this.visible = true
        // this.actions = []
        // if (this.autoClose) {
        //  setTimeout(() => {
        //    this.setNext()
        //  }, this.duration)
        // }

        this.queue.push({ ...param, style: 'notice', action: [] })
        setTimeout(() => this.setNext(), 200)
      },
      vnShowOverlay(param) {
        this.queue.push({ ...param, style: 'overlay', autoClose: false })
        setTimeout(() => this.setNext(), 200)
      },
      vnHideOverlay() {
        if (this.style === 'overlay') this.setDefault()
      },
      vnPopup(param) {
        // this.setDefault()
        // this.style = 'popup'
        // this.autoClose = false
        // this.message = param.message
        // if (param.component) this.component = param.component
        // if (param.options) this.options = param.options
        // if (param.actions) this.actions = param.actions
        // if (param.type) this.type = param.type
        // if (param.cssStyle) this.cssStyle = param.cssStyle
        // this.visible = true

        this.queue.push({ ...param, style: 'popup', autoClose: false })
        setTimeout(() => this.setNext(), 200)
      },
      handleClick(event, action) {
        this.visible = false
        this.setNext()
        if (action) setTimeout(() => action(), 300)
      },
      executeActions() {
        this.actions.forEach(action => {
          if (typeof action === 'function') {
            action()
          }
        })
      }
    },
    mounted() {
      EventBus.$on('vnShow', this.vnShow)
      EventBus.$on('vnPopup', this.vnPopup)
      EventBus.$on('vnShowOverlay', this.vnShowOverlay)
      EventBus.$on('vnHideOverlay', this.vnHideOverlay)
    },
    beforeDestroy() {
      EventBus.$off('vnShow', this.vnShow)
      EventBus.$off('vnPopup', this.vnPopup)
      EventBus.$off('vnShowOverlay', this.vnShowOverlay)
      EventBus.$off('vnHideOverlay', this.vnHideOverlay)
    }
  })
